import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import sessionStorage from '@flow/libs/utils/session-storage';

interface SidebarState {
  isSidebarExpanded: boolean;
  setSidebarExpanded: (expanded: boolean) => void;
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      isSidebarExpanded: true,
      setSidebarExpanded: (expanded: boolean) =>
        set(() => ({
          isSidebarExpanded: expanded,
        })),
    }),
    {
      name: 'sidebar-storage',
      storage: createJSONStorage(() => sessionStorage),
      // partialize the state to only save the isSidebarExpanded property to sessionStorage
      partialize: (state) => ({
        isSidebarExpanded: state.isSidebarExpanded,
      }),
    },
  ),
);
